// extracted by mini-css-extract-plugin
module.exports = {"member":"Member_member__1HCAD","member_nav":"Member_member_nav__2OBjE","member_nav_remark":"Member_member_nav_remark__3-ly0"};